require('./insuranceRequestCoverageDetailModal.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ constants
const { THIRD_STEP } = require('constants/index');
const { PLANS: { BASIC, HIGH } } = require('../../../insuranceConstants/insuranceRequestHome');
const { INSURANCES_TYPE } = require('../../../insuranceConstants/insuranceRequestTypes');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');

// @ components
const InsuranceRequestDetailsTabs = require('../../insuranceRequestDetails/insuranceRequestDetailsTabs');
const Coverages = require('../../insuranceRequestDetailsContactCenter/coverages');

class InsuranceRequestCoverageDetailModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedPlan: BASIC
        };
        this.onhandleChangeSelectedPlan = this.onhandleChangeSelectedPlan.bind(this);
    }

    componentWillMount() {
        const {
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData,
            policyComplementaryInformation,
            homeInsuranceType,
        } = this.props;

        const propertyCharacter = policyComplementaryInformation.get('propertyCharacter');
        const propertyUsage = policyComplementaryInformation.get('propertyUsage');

        getCoveragesAndPlansData(propertyUsage);
        getCoveragesAndPlansDetailsData(propertyUsage, propertyCharacter, HIGH, INSURANCES_TYPE[homeInsuranceType]);
    }

    onhandleChangeSelectedPlan(selectedPlan) {
        this.setState({
            selectedPlan,
        })
    }

    buildNormalContent() {
        const { coverage, policyComplementaryInformation, chosenPlan } = this.props;
        const consultivePlan = coverage.getIn(['steps', THIRD_STEP]);

        return (
            <section className="coverages-detail-modal__main-container">
                <InsuranceRequestDetailsTabs
                    onhandleChangeSelectedPlan={this.onhandleChangeSelectedPlan}
                    immInsuranceWizardStep={consultivePlan}
                    propertyInformation={policyComplementaryInformation}
                    showHeaderTabs={false}
                    chosenPlan={chosenPlan}
                    extraClass={'coverages-detail-modal__table'}
                />
            </section>
        );
    }

    buildContactCenterContent() {
        const { coverage, policyComplementaryInformation, chosenPlan } = this.props;

        const consultivePlan = coverage.getIn(['steps', THIRD_STEP]);

        return (
            <section className="coverages-detail-modal__main-container">
                <Coverages
                    onhandleChangeSelectedPlan={this.onhandleChangeSelectedPlan}
                    immInsuranceWizardStep={consultivePlan}
                    propertyInformation={policyComplementaryInformation}
                    showHeaderTabs={false}
                    chosenPlan={chosenPlan}
                    extraClass={'coverages-detail-modal__table'}
                />
            </section>
        );
    }

    buildContent() {
        const { coverage } = this.props;

        const consultivePlan = coverage.getIn(['steps', THIRD_STEP]);
        let content = <LoadingSection />;

        if (!consultivePlan.get('coveragesDetailsBasicData').isEmpty() &&
            !consultivePlan.get('coveragesDetailsMediumData').isEmpty() &&
            !consultivePlan.get('coveragesDetailsHighData').isEmpty()
        ) {
            if (__CONTACT_CENTER__) {
                content = this.buildContactCenterContent();
            } else {
                content = this.buildNormalContent();
            }
        }

        return content;
    }

    render() {
        const { isOpen, onHandleRequestClose } = this.props;
        const content = this.buildContent();

        return (
            <OKModal
                isOpen={isOpen}
                content={content}
                onCloseCallback={onHandleRequestClose}
                size="large"
                title="insuranceRequestHome-consultiveCoveragesDetails"
            />
        )
    }
}

InsuranceRequestCoverageDetailModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onHandleRequestClose: PropTypes.func.isRequired,
    coverage: PropTypes.object.isRequired,
    policyComplementaryInformation: PropTypes.object.isRequired,
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    getCoveragesAndPlansData: PropTypes.func.isRequired,
    chosenPlan: PropTypes.string.isRequired,
    homeInsuranceType: PropTypes.string,
};

InsuranceRequestCoverageDetailModal.defaultProps = {
    homeInsuranceType: INSURANCES_TYPE.HOME_NOT_RELATED,
}

module.exports = InsuranceRequestCoverageDetailModal;

